export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '90deg',
  'gradient-primary':'#A92F6E',
  'gradient-secondary': '#FFFFFF',

  'primary-color': '#BB357E',
  'secondary-color': '#646464',
  'auxiliary-color': '#BB357E',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#BB357E',
  'secondary-button-color': '#BB357E',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#BB357E',
  'secondary-button-border-hover': '#BB357E',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#121212',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-modal-color': '#FFFFFF',

  'filter-button-background': '#BB357E',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#BB357E',
  'entry-message-color': '#BB357E',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#BB357E;',
  'text-tertiary': '#FFFFFF;',
  'text-gray': '#4F4F4F',
  
  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#B6E3D6',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#BB357E',
  'bg-login-color': '#BB357E',
  'bg-login-page-color': '#BB357E',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#BB357E',
  'echeck-bar-color2': '#BB357E'
}